import React from 'react';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

/**
 * The error boundary for Terminal's routed sections.
 *
 * Mounted around the outlet only, so when a section throws while rendering the
 * Terminal header and its tabs stay mounted and the user can click through to
 * another section instead of facing a blank page.
 *
 * All this adds to `ErrorBoundary` is the current path as a reset key: changing
 * route clears the error, which makes navigating away a working escape hatch
 * rather than leaving the user stranded on a dead section.
 */
function TerminalErrorBoundary({ children }) {
  const location = useLocation();
  return (
    <ErrorBoundary
      resetKey={location.pathname}
      label="TerminalErrorBoundary"
      reloadLabel="Reload Terminal"
    >
      {children}
    </ErrorBoundary>
  );
}

export default TerminalErrorBoundary;
